import Vue from 'vue';
import Chart from 'chart.js';
import Chartkick from 'vue-chartkick';

import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;
Vue.use(Chartkick.use(Chart));
new Vue({
  router,
  store,
  // @ts-ignore
  vuetify,
  render: h => h(App),
}).$mount('#app');
